// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-buttonset {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-date-period-selection/v-date-period-selection.component.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ","sourcesContent":[".p-buttonset\n    display: flex"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
